import React from "react";
import "./TextLabelRenderer.scss";

const TextLabelRenderer = ({ element }) => {
  const { properties = {} } = element;

  const { value = "", fontSize = "14px", bold = false, italic = false, underline = false, textAlign = "left", verticalAlign = "top" } = properties;

  // Don't render if there's no text value
  if (!value || value.trim() === "") {
    return null;
  }

  const containerStyles = {
    display: "flex",
    alignItems: verticalAlign === "middle" ? "center" : verticalAlign === "bottom" ? "flex-end" : "flex-start",
    minHeight: "40px", // Ensure there's height for vertical alignment to work
  };

  const textStyles = {
    fontSize: ` ${fontSize}px`,
    fontWeight: bold ? "bold" : "normal",
    fontStyle: italic ? "italic" : "normal",
    textDecoration: underline ? "underline" : "none",
    textAlign,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    width: "100%",
  };

  return (
    <div className='text-label-renderer' style={containerStyles}>
      <span className='text-label-content d-block' style={textStyles}>
        {value}
      </span>
    </div>
  );
};

export default TextLabelRenderer;
